__turbopack_context__.v({
  "active": "NavigationMobile-module-scss-module___BoQMW__active",
  "close": "NavigationMobile-module-scss-module___BoQMW__close",
  "dialog": "NavigationMobile-module-scss-module___BoQMW__dialog",
  "dropdown": "NavigationMobile-module-scss-module___BoQMW__dropdown",
  "dropdown-item": "NavigationMobile-module-scss-module___BoQMW__dropdown-item",
  "environments": "NavigationMobile-module-scss-module___BoQMW__environments",
  "item": "NavigationMobile-module-scss-module___BoQMW__item",
  "languages": "NavigationMobile-module-scss-module___BoQMW__languages",
  "logo": "NavigationMobile-module-scss-module___BoQMW__logo",
  "main-item-list": "NavigationMobile-module-scss-module___BoQMW__main-item-list",
  "main-item-wrapper": "NavigationMobile-module-scss-module___BoQMW__main-item-wrapper",
  "my-bolt": "NavigationMobile-module-scss-module___BoQMW__my-bolt",
  "shape": "NavigationMobile-module-scss-module___BoQMW__shape",
  "small-bar": "NavigationMobile-module-scss-module___BoQMW__small-bar",
});
